import React, { useEffect, useState } from "react";
import { Container, Row, Card, Col, Button, Image, Badge } from "react-bootstrap";

import Breadcrumb from "Common/BreadCrumb";

import Swal from "sweetalert2";
import { useDeleteSalleMutation } from "features/salles/salleSlice";
import {
  UpdatePayload,
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingsMutation,
} from "features/smsSettings/smsSettings";

import sms_bg from "assets/images/undraw_message_sent_re_q2kl.svg";
const Parametres = () => {
  const { data, isLoading = [] } = useFetchSmsSettingsQuery();

  const [deleteSalle] = useDeleteSalleMutation();

  const notifySuccess = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Paramètres SMS modifiées avec succès",
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Sothing Wrong, ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSalle(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "La salle est supprimée.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "La salle est en sécurité :)",
            "info"
          );
        }
      });
  };
  const [updateSmsSettings] = useUpdateSmsSettingsMutation();

  const [formData, setFormData] = useState<UpdatePayload[]>([]);

  useEffect(() => {
    let parametre = [];
    if (data !== undefined && isLoading === false) {
      for (const sms_setting of data) {
        parametre.push({
          id: sms_setting?._id!,
          status: sms_setting.sms_status,
          name: sms_setting.service_name,
        });
      }
      setFormData(parametre);
    }
  }, [data, isLoading]);

  const toggleStatus = (index: number) => {
    let prevSmsSettings = [...formData];

    prevSmsSettings[index].status =
      prevSmsSettings[index].status === "1" ? "0" : "1";

    setFormData(prevSmsSettings);

    // updateSmsSettings(prevSmsSettings[index]);
  };

  const handleUpdate = () => {
    updateSmsSettings(formData).then(() => notifySuccess());
  };

  const activeCount = formData.filter((s) => s.status === "1").length;
  const inactiveCount = formData.filter((s) => s.status === "0").length;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Paramètres SMS" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-settings-3-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Services</p>
                      <h4 className="mb-0">{formData.length}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-check-double-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Activés</p>
                      <h4 className="mb-0 text-success">{activeCount}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                        <i className="ri-close-circle-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Désactivés</p>
                      <h4 className="mb-0 text-warning">{inactiveCount}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-message-2-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">SMS</p>
                      <Badge bg="info-subtle" text={"info" as any} className="fs-12 px-2 py-1">
                        <i className="ri-chat-settings-line me-1" />
                        Configuration
                      </Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Settings Card */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="align-items-center">
                  <Col>
                    <h5 className="card-title mb-0 d-flex align-items-center gap-2">
                      <i className="ri-chat-settings-line text-primary" />
                      Configuration des services SMS
                    </h5>
                  </Col>
                  <Col className="text-end">
                    <Button
                      variant="primary"
                      onClick={handleUpdate}
                      className="d-flex align-items-center gap-1 ms-auto"
                    >
                      <i className="ri-save-line fs-16" />
                      Mettre à jour
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col lg={5}>
                    {formData?.map((setting, index) => (
                      <div
                        key={setting.id}
                        className="d-flex align-items-center justify-content-between p-3 border-bottom border-bottom-dashed"
                      >
                        <div className="d-flex align-items-center gap-3">
                          <div className="avatar-xs flex-shrink-0">
                            <div className={`avatar-title ${setting.status === "1" ? "bg-success-subtle text-success" : "bg-secondary-subtle text-secondary"} rounded-circle fs-16`}>
                              <i className="ri-message-2-line" />
                            </div>
                          </div>
                          <div>
                            <span className="fw-medium fs-13 d-block">{setting.name}</span>
                            {setting.status === "1" ? (
                              <Badge bg="success-subtle" text={"success" as any} className="fs-11 mt-1">
                                Activé
                              </Badge>
                            ) : (
                              <Badge bg="warning-subtle" text={"warning" as any} className="fs-11 mt-1">
                                Désactivé
                              </Badge>
                            )}
                          </div>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            key={setting?.id!}
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`flexSwitchCheckChecked-${index}`}
                            checked={setting.status === "1"}
                            onChange={() => toggleStatus(index)}
                          />
                        </div>
                      </div>
                    ))}
                    {formData.length === 0 && (
                      <div className="text-center py-5">
                        <i className="ri-settings-3-line fs-1 text-muted d-block mb-2" />
                        <p className="text-muted mb-0">Aucun paramètre trouvé</p>
                      </div>
                    )}
                  </Col>
                  <Col
                    lg={7}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Image src={sms_bg} style={{ maxWidth: "400px" }} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Parametres;
